/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderInfoForInboundPictureOrderVo } from './OrderInfoForInboundPictureOrderVo';
import {
    OrderInfoForInboundPictureOrderVoFromJSON,
    OrderInfoForInboundPictureOrderVoFromJSONTyped,
    OrderInfoForInboundPictureOrderVoToJSON,
    OrderInfoForInboundPictureOrderVoToJSONTyped,
} from './OrderInfoForInboundPictureOrderVo';

/**
 * 
 * @export
 * @interface ResponseOrderInfoForInboundPictureOrderVo
 */
export interface ResponseOrderInfoForInboundPictureOrderVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseOrderInfoForInboundPictureOrderVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseOrderInfoForInboundPictureOrderVo
     */
    message?: string;
    /**
     * 
     * @type {OrderInfoForInboundPictureOrderVo}
     * @memberof ResponseOrderInfoForInboundPictureOrderVo
     */
    data?: OrderInfoForInboundPictureOrderVo;
}

/**
 * Check if a given object implements the ResponseOrderInfoForInboundPictureOrderVo interface.
 */
export function instanceOfResponseOrderInfoForInboundPictureOrderVo(value: object): value is ResponseOrderInfoForInboundPictureOrderVo {
    return true;
}

export function ResponseOrderInfoForInboundPictureOrderVoFromJSON(json: any): ResponseOrderInfoForInboundPictureOrderVo {
    return ResponseOrderInfoForInboundPictureOrderVoFromJSONTyped(json, false);
}

export function ResponseOrderInfoForInboundPictureOrderVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseOrderInfoForInboundPictureOrderVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : OrderInfoForInboundPictureOrderVoFromJSON(json['data']),
    };
}

export function ResponseOrderInfoForInboundPictureOrderVoToJSON(json: any): ResponseOrderInfoForInboundPictureOrderVo {
    return ResponseOrderInfoForInboundPictureOrderVoToJSONTyped(json, false);
}

export function ResponseOrderInfoForInboundPictureOrderVoToJSONTyped(value?: ResponseOrderInfoForInboundPictureOrderVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': OrderInfoForInboundPictureOrderVoToJSON(value['data']),
    };
}

